import { APIToken } from '@ardoq/api-types';
import {
  deleteEntity,
  updateEntity,
  Method,
  toRequestOptions,
  fetchJson,
  fetchEntities,
} from './api';
import { ApiResponse } from './types';

const create = async (payload: {
  type: string;
  description: string;
}): ApiResponse<APIToken> => {
  const request = new Request(
    '/api/token',
    toRequestOptions(Method.POST, payload)
  );
  return fetchJson<APIToken>(request);
};

export const tokenApi = {
  create,
  update: updateEntity<APIToken>('token'),
  delete: deleteEntity('token'),
  fetchAll: fetchEntities<APIToken>('token'),
  fetchAllOrg: fetchEntities<APIToken>('token/org/all-tokens'),
};
